export interface ResponsesState {
	responses: Response[];
	filteredResponses: Response[];
	failedResponse: Response;
	pageIndex: number;
	pageSize: number;
	filter: string;
	filterPageIndex: number;
	allResponsesRetrieved: boolean;
	allFilteredResponsesRetrieved: boolean;
	responseTableIsBusy: boolean;
	alarmModalOpened: boolean;
	alarmActionsOpened: boolean;
	currentAlarm: Response;
	currentAlarmAction: AlarmAction;
	supportedAlarmActionTypes: AlarmActionType[];
	alarmActions: AlarmAction[];
	triggerTestResponseResult: ResponseTestResult | null;
	alarmSetupModalLoaded: boolean;
}

export interface Response {
	responseID: number;
	serverID: number;
	input1: number;
	input2: number;
	serverTypeEventNum: number;
	groupID: number;
	title: string;
	armed: number;
	toggleArmAt: Date;
	disarmReasonId: number;
	priority: number;
	autoHandle: boolean;
	lastOccurred: number;
	scriptId: number;
	runawayThreshold: number;
	runawayMinutes: number;
	runawayStarted: Date;
	runawayCount: number;
	awaitingRestore: boolean;
	expected: boolean;
	responseAlarmTypeId: number;
	routingGroupId: number;
	extraValue: string;
	syncIdentifier: string;
	positionX: string;
	positionY: string;
	positionZ: string;
	expectedReceived: number;
	matchRadius: number;
	matchGeofence: boolean;
	isRaiseIndividual: boolean;
	isRaiseGrouped: boolean;
	disarmNote: string;
	selectedServer: any;
	permissions: any;
	deviceTitle: string;
	serverTypeEventTitle: string;
	alarmGrouping: string;
	responseAlarmTypeID: number | null;
	scriptID: number | null;
	serverTypeId?: number;
}

export interface AlarmActionType {
	responseActionTypeId: number;
	title: string;
}

export interface AlarmAction {
	responseActionID: number;
	responseID: number;
	responseActionTypeID: number;
	orderNum: number;
	objectID: number;
	settingsMeta: string;
	armed: boolean;
	readOnly: boolean;
	deviceTitle: string;
	description: string;
}

export enum AlarmActionTypeIdentifier {
	RecordCamera = 1,
	ActivateRelay = 2,
	SendEmail = 4,
	ChangeSiteArmStatus = 6,
	ChangeInputArmStatus = 7,
	SendNotification = 10
}

export interface ResponseTestResult {
	added: boolean;
	responseArmed: boolean;
	groupArmed: boolean;
	responseAutoHandled: boolean;
	triggeredAt: string | null;
}

export interface ResponseAlarmType {
	groupId: number;
	responseAlarmTypeID: number;
	title: string;
}
